export const hexToRgba = (hex: string, alpha: number): string | null => {
  if (typeof hex !== "string" || hex[0] !== "#") return null;
  let h = hex.slice(1);
  if (h.length === 3) {
    h = h
      .split("")
      .map((c) => c + c)
      .join("");
  }
  if (h.length !== 6 || /[^0-9a-fA-F]/.test(h)) return null;
  const n = parseInt(h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
};

export const isDefaultLanguage = (lang: string): boolean =>
  lang === "English" || lang === "en" || lang === "EN";

export const normaliseLanguage = (lang: string | undefined | null): string =>
  !lang || isDefaultLanguage(lang) ? "English" : lang;

export const availableLanguages = (
  defaultLanguage: string | undefined,
  translations: Record<string, unknown> | undefined
): string[] => {
  const pinned = ["English"];
  const normalised = normaliseLanguage(defaultLanguage);
  if (normalised !== "English") pinned.push(normalised);
  const rest = Object.keys(translations || {})
    .filter((lang) => !pinned.includes(lang))
    .sort((a, b) => a.localeCompare(b, "en"));
  return [...pinned, ...rest];
};
